// extracted by mini-css-extract-plugin
export default {"wrapper":"Iy-z","button":"Jy-z","alternate":"Ky-z","disabled":"Ly-z","paymentWarning":"My-z","fadeIn":"Ny-z"};